import {LIST_LOCK_NUMBER,FETCH_LOCK_NUMBER} from "./types";

const init = {
    isLoading:false,
    list:[]
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_LOCK_NUMBER:
            return {
                ...state,
                isLoading: true
            };
        case LIST_LOCK_NUMBER:
            return {
                ...state,
                isLoading: false,
                list: payload
            };
        default:
            return state;
    }
}